export const environment = {
    production: true,
    urls: {
        api: 'https://api.n2g-iona.net/v2/',
        auth: 'https://iona-live.wla-backend.de/auth'
    }
};

